
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Key } from 'lucide-react';
import { ThemeToggle } from '@/components/theme/ThemeToggle';

const ApiSettings = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex justify-between items-center">
          <span>API Settings</span>
          <ThemeToggle />
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Configure API settings for the AI service.
          </p>
          
          <div className="flex gap-4 items-end">
            <div className="flex-1 space-y-2">
              <label className="text-sm font-medium">API Key</label>
              <Input type="password" placeholder="••••••••••••••••••••••••••" />
            </div>
            <Button>
              <Key size={16} className="mr-2" />
              Update Key
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ApiSettings;
